export enum PaymentType {
  OneTime = 'one-time',
  Recurring = 'recurring',
  Prorated = 'prorated',
  Unknown = 'unknown',
}
